// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/commonComponents/Button';
import PropTypes from 'prop-types';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import InputField from 'components/commonComponents/InputField';
import { useSelector } from 'react-redux';
import { APP_ID } from 'config/constants';
import { Alert, Modal } from 'antd';

const WalletRedeem = (props) => {
  const { onClose, open, onRedeemed } = props;
  const { currentLang, userDetails } = useSelector((store) => store.commonData);
  const { t } = useTranslation();
  const [dataSet, setData] = useState({});
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { fullname, email, phone } = dataSet;
  const [errorAlert, setErrorAlert] = useState({ msg: '', key: Math.random(), open: false, severity: '' })

  // Prefilled from the account, but editable: the account name is a display
  // name and may not be the one the transfer has to be made out to.
  useEffect(() => {
    if (open) {
      setData({
        fullname: userDetails?.fullname ? userDetails?.fullname : userDetails?.username ? userDetails?.username : '',
        email: userDetails?.email ? userDetails?.email : '',
        phone: ''
      });
      setError({});
    }
  }, [open]);

  const handleOnChange = (key) => (_value) => {
    if (_value) {
      setError({
        ...error,
        [key]: null
      });
    }
    setData({
      ...dataSet,
      [key]: _value
    });
  };

  const handleSave = async () => {
    const errors = {
      fullname: !fullname,
      email: !email,
      phone: !phone,
    };

    setError(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('action', 'redeem')
    formData.append('appId', APP_ID)
    formData.append('language', currentLang?.id)
    formData.append('fullname', fullname)
    formData.append('email', email)
    formData.append('phone', phone)
    const res = await fetchData(restAPIs.walletRedeem(formData));
    if (res.statusCode === 200) {
      setErrorAlert({ msg: res.errormessage ? res.errormessage : t('redeem_request_sent'), key: Math.random(), open: true, severity: 'success' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
        onRedeemed ? onRedeemed() : onClose();
      }, 2000);
    } else {
      setErrorAlert({ msg: res.errormessage ? res.errormessage : t('something_went_wrong_try_after_sometime'), key: Math.random(), open: true, severity: 'error' });
      setTimeout(() => {
        setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
      }, 3000);
    }
    setIsLoading(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        keyboard={false}
        maskClosable={false}
        footer={null}
        closable={false}
      >
        <div className='__common_model_content'>
          <h3 className='____common_model_class_head'> {t('redeem')}</h3>
          <p style={{ marginBottom: '15px' }}>{t('redeem_hint')}</p>
          <div style={{ marginBottom: '20px', width: '100%' }}>
            <InputField
              onChange={handleOnChange('fullname')}
              value={fullname}
              label={t('full_name')}
              placeholder={t('full_name')}
              type='text'
              error={error.fullname}
            />
          </div>
          <div style={{ marginBottom: '20px', width: '100%' }}>
            <InputField
              onChange={handleOnChange('email')}
              value={email}
              label={t('email')}
              placeholder={t('email')}
              type='email'
              error={error.email}
            />
          </div>
          <div style={{ marginBottom: '20px', width: '100%' }}>
            <InputField
              onChange={handleOnChange('phone')}
              value={phone}
              label={t('mobile_number')}
              placeholder={t('mobile_number')}
              type='tel'
              error={error.phone}
            />
          </div>
          <div className='d-flex align-items-center justify-content-end' style={{ marginTop: ' 15px', gridGap: '10px' }}>
            <a onClick={() => handleClose(false)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</a>
            <Button
              withLoader
              loading={isLoading}
              disabled={isLoading}
              handleOnClick={handleSave}
              label={t('send_request')}
            />
          </div>
          {errorAlert && errorAlert.open ?
            <Alert severity={errorAlert.severity} sx={{ width: '100%' }}>
              {errorAlert.msg}
            </Alert> : ''}
        </div>
      </Modal>
    </>
  );
};

export default WalletRedeem;

WalletRedeem.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onRedeemed: PropTypes.func
};
